<template>
  <form action="" id="liveRegistrationFormModal">
    <div class="modal-card" style="width: auto">
      <header class="modal-card-head">
        <p class="modal-card-title">配信情報</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <b-field label="タイトル">
          <b-input
            type="text"
            v-model="title"
            placeholder="今日のテーマは"
            required
          >
          </b-input>
        </b-field>

        <b-field label="配信内容">
          <textarea
            class="textarea"
            placeholder="今日の内容は"
            v-model="aboutLive"
          ></textarea>
        </b-field>
        <b-field label="サムネイル">
          <b-upload v-model="thumbnailFile" drag-drop expanded>
            <section class="section">
              <div class="content has-text-centered">
                <p>
                  <b-icon icon="upload" size="is-large"></b-icon>
                </p>
                <p>Drop your files here or click to upload</p>
              </div>
            </section>
          </b-upload>
        </b-field>

        <div v-if="thumbnailFile" class="tags">
          <span class="tag is-light">
            {{ thumbnailFile.name }}
          </span>
        </div>
      </section>
      <footer class="modal-card-foot">
        <b-button label="Close" @click="$emit('close')" />
        <b-button label="送信" type="is-primary" @click="submitForm" />
      </footer>
    </div>
  </form>
</template>

<script>
export default {
  name: 'LiveRegistrationFormModal',
  props: ['email', 'password'],
  data() {
    return {
      title: '',
      aboutLive: '',
      thumbnailFile: null
    };
  },
  methods: {
    async submitForm() {
      try {
        const payload = {
          userId: this.$store.state.auth.uid,
          title: this.title,
          aboutLive: this.aboutLive,
          thumbnailFile: this.thumbnailFile,
          playbackUrl: this.$store.state.ivs.channel.playbackUrl
        };
        await this.$store.dispatch('startNewLiveStreaming', payload);
        this.$emit('close');
        const path = `/live/console/${this.$store.state.user.recentLiveId}`;
        this.$router.push(path);
      } catch (err) {
        console.error(err);
        return;
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
